export enum SpaceDocumentType {
  INDIVIDUAL_IDENTITIES_IMPORT = 'INDIVIDUAL_IDENTITIES_IMPORT',
  COMPANY_IDENTITIES_IMPORT = 'COMPANY_IDENTITIES_IMPORT',
}
